/** Verified parent release gate for CONTXT v2.13.0 (Prod default off). */
export const RELEASE_GATE_V2_13_0 = 'contxt-v2.13.0'

/** Verified parent release gate for CONTXT v2.13.4 (Prod default off). */
export const RELEASE_GATE_V2_13_4 = 'contxt-v2.13.4'

/** FE-2493: lane profile geofence messaging and location text styling. */
export const LANE_PROFILE_GEOFENCE_MESSAGING_GATE =
  'cc-6799-fix-conflicting-geofence-ranges-and-text-color'

/** FE-2460: product profile PTR duration summary label decomposition (no hour rounding). */
export const FE_2460_FIX_PTR_DURATION_SUMMARY_LABEL_FORMATTER_GATE =
  'fe-2460-fix-ptr-duration-summary-label-formatter'

export const isPtrDurationSummaryLabelFormatterFixEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2460_FIX_PTR_DURATION_SUMMARY_LABEL_FORMATTER_GATE))

/** FE-2544: tenant long logo + sizing for activity history PDF exports. */
export const PDF_TENANT_LOGO_FIX_GATE =
  'fe_2544_in-peli-tenant-for-downloaded-pdf-reports-showing-contxt-logo'

export const isTenantPdfLogoFixEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(PDF_TENANT_LOGO_FIX_GATE))

/** CC-6812: public product share temperature report min/max, TOR, and excursions. */
export const PUBLIC_PRODUCT_SHARE_TEMPERATURE_REPORT_FIX_GATE =
  'cc-6812-public-product-share-temperature-report-missing-minmax-tor-excursions'

export const isPublicProductShareTemperatureReportFixEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(PUBLIC_PRODUCT_SHARE_TEMPERATURE_REPORT_FIX_GATE))

/** CC-6037: Release 3 shipments tag pivot — org tags catalog store (UUID-only reads). */
export const SHIPMENTS_TAG_PIVOT_GATE = 'cc-6037-release-3-shipments-tag-pivot'

export const isShipmentsTagPivotEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(SHIPMENTS_TAG_PIVOT_GATE))

/** FE-2686: Create New Shipment breadcrumb + favorites map refresh fixes. */
export const FE_2686_CORRECT_BREADCRUMB_BEHAVIOR_GATE = 'fe-2686-correct-breadcrumb-behavior'

export const isCorrectBreadcrumbBehaviorEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2686_CORRECT_BREADCRUMB_BEHAVIOR_GATE))

/** FE-2735: hide removed devices on Shipment Details (list, PDF, map, and Command Center v3). */
export const FE_2735_REMOVED_DEVICES_SHIPMENT_DETAILS_GATE =
  'fe-2735-removed-devices--shipmentdetails'

export const isRemovedDevicesHiddenOnShipmentDetails = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2735_REMOVED_DEVICES_SHIPMENT_DETAILS_GATE))

/** FE-2736: lock inline edits on saved device rows after shipment leaves created. */
export const FE_2736_LOCK_INLINE_DEVICES_AFTER_CREATED_GATE =
  'fe-2736-lock-inline-devices-after-created'

export const isLockInlineDevicesAfterCreatedEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2736_LOCK_INLINE_DEVICES_AFTER_CREATED_GATE))

/** CC-6994 / FE-2750: lock device edits on shipments with a completed product release review. */
export const CC_6994_DEVICES_LOCK_ON_REVIEWED_RELEASE_GATE =
  'cc-6994-devices-can-not-be-removed-from-approved-product-release-shipments'

export const isDevicesLockedOnReviewedReleaseEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6994_DEVICES_LOCK_ON_REVIEWED_RELEASE_GATE))

/** CC-7059 / FE-2762: block document delete on shipments with a completed product release review. */
export const CC_7059_REVIEWED_RELEASE_DOCUMENT_DELETE_LOCK_GATE =
  'cc-7059-documents-can-still-be-deleted-after-a-product-release-review-is'

export const isReviewedReleaseDocumentDeleteLockEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7059_REVIEWED_RELEASE_DOCUMENT_DELETE_LOCK_GATE))

/** CC-6928: persist device buckets via update_shipment_devices_v1 (server rebuilds handling_units). */
export const CC_6928_CALL_HU_REBUILD_RPC_GATE = 'cc-6928-call-hu-rebuild-rpc'

export const isHuRebuildRpcEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6928_CALL_HU_REBUILD_RPC_GATE))

/** CC-7070 / FE-2804: new lane profiles start with the Product Stability trigger on (all states). */
export const FE_2804_PRODUCT_STABILITY_DEFAULT_ON_GATE = 'fe-2804-product-stability-default-on'

export const isProductStabilityDefaultOnEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2804_PRODUCT_STABILITY_DEFAULT_ON_GATE))

/** FE-2748: taller tag group flyout in tag pickers (about 6.5 rows visible). */
export const FE_2748_TAGS_GROUP_FLYOUT_GATE = 'fe-2748-tags-group-flyout'

/**
 * FE-2964: workflow activity history shows the tag-group chip only (not group UUID or color hex).
 * Also skips repeat `get_org_tag_groups_v1` calls after the catalog has loaded; realtime still refreshes the pinned group.
 */
export const FE_2964_DISPLAY_TAG_GROUP_NAMES_WITH_COLOR_ONLY_IN_ACTIVITY_HISTORY_GATE =
  'fe-2964-display-tag-group-names-with-color-only-in-activity-history'

export const isTagGroupInActivityHistoryEnabled = (statsigClient) =>
  Boolean(
    statsigClient?.checkGate?.(
      FE_2964_DISPLAY_TAG_GROUP_NAMES_WITH_COLOR_ONLY_IN_ACTIVITY_HISTORY_GATE,
    ),
  )

export const TAGS_GROUP_FLYOUT_MAX_HEIGHT_CLASS = 'max-h-[234px]'
export const TAGS_GROUP_FLYOUT_LEGACY_MAX_HEIGHT_CLASS = 'max-h-[110px]'
export const TAGS_GROUP_FLYOUT_ROW_HEIGHT_PX = 36
export const TAGS_GROUP_FLYOUT_CONTAINER_PADDING_PX = 16

export const isTagsGroupFlyoutEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2748_TAGS_GROUP_FLYOUT_GATE))

export const getTagsGroupFlyoutMaxHeightClass = (statsigClient) =>
  isTagsGroupFlyoutEnabled(statsigClient)
    ? TAGS_GROUP_FLYOUT_MAX_HEIGHT_CLASS
    : TAGS_GROUP_FLYOUT_LEGACY_MAX_HEIGHT_CLASS

export const getTagsGroupFlyoutHeightPx = (tagCount, statsigClient) => {
  const safeTagCount = Math.max(1, tagCount || 0)
  const maxContentHeightPx = isTagsGroupFlyoutEnabled(statsigClient) ? 234 : 110
  const contentHeightPx = Math.min(
    safeTagCount * TAGS_GROUP_FLYOUT_ROW_HEIGHT_PX,
    maxContentHeightPx,
  )

  return contentHeightPx + TAGS_GROUP_FLYOUT_CONTAINER_PADDING_PX
}

export const getTagsGroupFlyoutTop = (
  relativeTop,
  containerHeight,
  statsigClient,
  tagCount = 1,
) => {
  if (!isTagsGroupFlyoutEnabled(statsigClient)) {
    return relativeTop
  }

  const flyoutHeight = getTagsGroupFlyoutHeightPx(tagCount, statsigClient)
  const maxTop = Math.max(0, containerHeight - flyoutHeight)
  return Math.min(relativeTop, maxTop)
}

/**
 * CC-6892: when on, carrier timeline callers use `get_carrier_timeline_v1` by name
 * (not api_version_matrix). Ship that RPC on the env before enabling — otherwise the
 * timeline fetch fails empty. UI label mapping in CarrierTimeLine is gate-independent.
 */
export const CC_6892_OCEAN_CARRIER_TIMELINE_LABELS_GATE = 'cc-6892-fe-ocean-carrier-timeline-labels'

export const GET_CARRIER_TIMELINE_V1_RPC = 'get_carrier_timeline_v1'

export const isOceanCarrierTimelineLabelsEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6892_OCEAN_CARRIER_TIMELINE_LABELS_GATE))
/** CC-7068: hide the Display preferences button on the Command Center map toolbar. */
export const CC_7068_REMOVE_DISPLAY_PREFERENCE_BUTTON_MAP_VIEW_GATE =
  'cc-7068-fe-remove-display-preference-button-map-view'

export const isRemoveDisplayPreferenceButtonOnMapViewEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7068_REMOVE_DISPLAY_PREFERENCE_BUTTON_MAP_VIEW_GATE))

/** CC-6965 / FE-2702: Command Center list layout per custom global view (`views.shipment_list_preference`). */
export const CC_6965_FE_VIEW_LIST_LAYOUT_GATE = 'cc-6965-fe-saved-column-preferences-isolated'

export const isCommandCenterViewListLayoutPerViewEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6965_FE_VIEW_LIST_LAYOUT_GATE))

/** CC-6904 / FE-2659: light (box open / closed) markers on the device temperature chart. */
export const CC_6904_DEVICE_TEMPERATURE_LIGHT_EVENTS_GATE =
  'cc-6904-fe-device-temperature-light-events'

export const isDeviceTemperatureLightEventsEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6904_DEVICE_TEMPERATURE_LIGHT_EVENTS_GATE))

/** CC-7096 / FE-2877: preserve device provider casing in manual add-temperature-data payloads. */
export const CC_7096_MANUAL_DEVICE_PROVIDER_CASE_GATE =
  'cc-7096-fe-preserve-manual-device-provider-case'

export const isManualDeviceProviderCasePreservedEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7096_MANUAL_DEVICE_PROVIDER_CASE_GATE))

/** CC-7111 / FE-2893: handling_units v4 product_lines[].line_items[] material mapping. */
export const CC_7111_HANDLING_UNIT_MATERIALS_V4_GATE = 'cc-7111-fe-handling-unit-materials-v4'

export const isHandlingUnitMaterialsV4Enabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7111_HANDLING_UNIT_MATERIALS_V4_GATE))

/** CC-7152 / FE-2905: show newly added device rows at the top of each device section. */
export const CC_7152_NEW_DEVICE_FIELDS_AT_TOP_GATE = 'cc-7152-fe-show-device-fields-top'

export const isNewDeviceFieldsAtTopEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7152_NEW_DEVICE_FIELDS_AT_TOP_GATE))

/** CC-7160 / FE-2919: show handling_unit_display_id instead of orphan UUID handling units. */
export const CC_7160_HANDLING_UNIT_READABLE_DISPLAY_ID_GATE = 'cc-7160-fe-handling-unit-readable-id'

export const isHandlingUnitReadableDisplayIdEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7160_HANDLING_UNIT_READABLE_DISPLAY_ID_GATE))

/** CC-6948 / FE-2708: full device ID tooltip with copy on shipment details devices table. */
export const CC_6948_SHIPMENT_DEVICE_ID_COPY_GATE = 'cc-6948-fe-full-device-id-copy'

export const isShipmentDeviceIdCopyEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_6948_SHIPMENT_DEVICE_ID_COPY_GATE))
/** CC-7175 / FE-2942: sign users out after 2 hours with no activity in any open tab. */
export const CC_7175_IDLE_SIGN_OUT_GATE = 'cc-7175-fe-idle-sign-out'

export const isIdleSignOutEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7175_IDLE_SIGN_OUT_GATE))

/** CC-7183 / FE-2957: check Product Release (not Command Center) permissions on /shipment/product-release pages. */
export const FE_2957_PRODUCT_RELEASE_PATH_PERMISSION_CHECK_GATE =
  'fe-2957-product-release-path-permission-check'

export const isProductReleasePathPermissionCheckEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2957_PRODUCT_RELEASE_PATH_PERMISSION_CHECK_GATE))
/** CC-7181 / FE-2955: allow completed shipments to be cancelled from the edit menu. */
export const CC_7181_CANCEL_COMPLETED_SHIPMENTS_GATE = 'cc-7181-fe-cancel-completed-shipments'

export const isCancelCompletedShipmentsEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7181_CANCEL_COMPLETED_SHIPMENTS_GATE))

/** FE-2956: update every mounted Header when the release_version_tracker broadcast arrives. */
export const UPDATE_MOUNTED_VERSION_ALERTS_GATE = 'update-mounted-version-alerts'

export const isUpdateMountedVersionAlertsEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(UPDATE_MOUNTED_VERSION_ALERTS_GATE))

/** CC-7195 / FE-2967: first Command Center load uses the selected view's filters (Pylon 1470). */
export const FE_2967_FIRST_LOAD_VIEW_FILTERS_GATE = 'fe-2967-first-load-view-filters'

export const isFirstLoadViewFiltersFixEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2967_FIRST_LOAD_VIEW_FILTERS_GATE))

/** FE-2969: keep the active view selected after Remove Default, without refetching. */
export const FE_2969_KEEP_CUSTOM_VIEW_SELECTED_AFTER_REMOVE_DEFAULT_GATE =
  'fe-2969-keep-custom-view-selected-after-removing-its-default-setting'

export const isKeepCustomViewSelectedAfterRemoveDefaultEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_2969_KEEP_CUSTOM_VIEW_SELECTED_AFTER_REMOVE_DEFAULT_GATE))

/** Land the user on a Command Center view right after they create it, not the previous view. */
export const LAND_ON_NEW_VIEW_AFTER_CREATE_GATE = 'land-on-new-view-after-create'

export const isLandOnNewViewAfterCreateEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(LAND_ON_NEW_VIEW_AFTER_CREATE_GATE))

/** CC-7266 / FE-3039: hotfix (patch-only) releases don't show the release popup to unpinned users. */
export const CC_7266_HOTFIX_RELEASE_POPUP_GATE =
  'cc-7266-release-popup-appears-for-hotfix-releases-in-production'

export const isHotfixReleasePopupFixEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(CC_7266_HOTFIX_RELEASE_POPUP_GATE))
/**
 * CC-7262 / FE-3036: show event resolutions and shipment reviews in Command Center activity history.
 * On the Temperature Dashboard it only adds the older-row fallback, and only where
 * product-release-v1 is also on (that gate owns the details there).
 */
export const FE_3036_CC_ACTIVITY_EVENT_RESOLUTION_AND_REVIEW_GATE =
  'fe-3036-cc-activity-event-resolution-and-review'

export const isCommandCenterActivityEventAuditEnabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(FE_3036_CC_ACTIVITY_EVENT_RESOLUTION_AND_REVIEW_GATE))
